var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{ref:"map",staticStyle:{"width":"100%","min-height":"220px","max-height":"250px","border-radius":"15px 15px 0px 0px","overflow":"hidden"},attrs:{"zoom":_vm.zoom,"center":_vm.location}},[_c('GmapMarker',{attrs:{"position":_vm.location}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }